import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * The layout for one engine's SQL sync pages: the list (index), the create wizard (`new`) and the
 * import detail (`$sqlImportId`) render in its outlet. The gating and the workspace resolution
 * live in each child, since the list forwards accounts that Reverse ETL replaced and the others
 * do not.
 */
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type')({
  component: Outlet,
});
